import { createWrapContext } from './context';
export default createWrapContext();
export var FormItemGroupWrapContext = createWrapContext();
export var FormControlGroupWrapContext = createWrapContext();